import { AVAnalyticsEventNames } from '@/utils/enums';

const initialState = {
  isMultiWidget: false,
  AVAnalyticsEventsFired: [], // tracking because we only want to fire the same event once per session
  shiftDigitalAnalytics: false,
};
const mutations = {
  AV_ANALYTICS_EVENT(state, payload) {
    state.AVAnalyticsEventsFired.push(payload);
  },
  SET_SHIFT_DIGITAL_ANALYTICS(state, payload) {
    state.shiftDigitalAnalytics = payload;
  },
};
const actions = {
  formEngagementEvent({ commit }, payload) {
    const eventData = {
      name: AVAnalyticsEventNames.FORM_ENGAGEMENT,
      elementText: payload.elementText,
      route: payload.route.path,
    };
    commit('AV_ANALYTICS_EVENT', eventData);
  },
  ctaInteractionEvent({ commit }, payload) {
    const eventData = {
      name: AVAnalyticsEventNames.CTA_INTERACTION,
      elementText: payload.elementText,
      eventActionResult: payload.eventActionResult,
      elementSubtype: payload.elementSubtype,
      route: payload.route.path,
    };
    commit('AV_ANALYTICS_EVENT', eventData);
  },
  leadCompleteEvent({ commit, rootState }) {
    const eventData = {
      name: AVAnalyticsEventNames.LEAD_COMPLETE,
      leadId: rootState.lead.leadId,
      route: rootState.route.path,
    };
    commit('AV_ANALYTICS_EVENT', eventData);
  },
  // eslint-disable-next-line consistent-return
  initShiftDigital({ rootState, dispatch }) {
    try {
      const CLIENT_ID = rootState.business.info.analytics.shiftDigital.sdClientId;
      const RETAILER_ID = rootState.business.info.analytics.shiftDigital.sdRetailerId;

      // this block throws a lot of errors - disable eslint for now
      /* eslint-disable */
      if (CLIENT_ID && RETAILER_ID && CLIENT_ID !== '' && RETAILER_ID !== '') {
        return (function (s, h, i, f, t, d, g, l) {
          s[d] = s[d] || function () {
            (s[d].q = s[d].q || []).push(arguments)
          },
            s[d].l = 1 * new Date();
          g = h.createElement(i),
            l = h.getElementsByTagName(i)[0];
          g.async = 1;
          g.src = f + '?containerId=' + t + '&dl=' + d;
          g.onload = () => dispatch('createShiftDigitalSession', true);
          g.onerror = () => dispatch('onErrorForShiftDigital');
          l.parentNode.insertBefore(g, l);
          return g;
        })
        (window, document, 'script', process.env.VUE_APP_SHIFT_DIGITAL_SERVER_URL, CLIENT_ID, 'sd');
      }
      /* eslint-enable */
    } catch (error) {
      dispatch('createShiftDigitalSession', false);
      this._vm.$log('Error in analytics.js: error running initShiftDigital script', error);
    }
  },
  createShiftDigitalSession({ commit, rootState }, payload) {
    commit('SET_SHIFT_DIGITAL_ANALYTICS', payload);
    if (payload) {
      window.sd(
        'create',
        rootState.business.info.analytics.shiftDigital.sdClientId,
        rootState.business.info.analytics.shiftDigital.sdRetailerId,
        process.env.VUE_APP_SHIFT_DIGITAL_PROVIDER_ID
      );
    }
  },
  onErrorForShiftDigital() {
    this._vm.$log('Error in analytics.js: failed to import Shift Digital SDK', null);
  },
};
const getters = {};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
